module.exports = __webpack_public_path__ + "static/media/jsi.e8bc1728.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/TheMoshiDifference/jsi.jpg
// module id = 188
// module chunks = 0